module.exports = __webpack_public_path__ + "img/i1.73d81bec.jpg";